export function getTenantIdentifier() {
    if (window.location.hostname !== "localhost") {
        let addInSubdomain = window.location.hostname.split(".")[0];
        let tenantId = addInSubdomain.split("-");
        return tenantId[tenantId.length - 1];
    } else {
        return 'client0' 
    }
}